import * as React from "react";
import {Box, IconButton, Tooltip, Typography} from "@mui/material";
import {Fullscreen} from "@mui/icons-material";

export interface SectionedTableProps {
    /** Section heading displayed above the table */
    title: string;
    /** Tooltip text for the fullscreen button */
    fullscreenTooltip: string;
    /** The table element to render (may include its own filter row) */
    tableNode: React.ReactNode;
    /** Called when the fullscreen button is clicked */
    onFullscreen: () => void;
}

/**
 * Layout wrapper that renders a titled section with a fullscreen expand button
 * and the table below. The table may include its own filter row.
 * Used inside BidderOverviewPage and RequesterOverviewPage.
 */
export const SectionedTable: React.FC<SectionedTableProps> = ({
    title,
    fullscreenTooltip,
    tableNode,
    onFullscreen
}) => (
        <Box display="flex" flexDirection="column" height="100%" minHeight={240} overflow="hidden">
            <Box display="flex" alignItems="center" paddingBottom={1}>
                <Typography variant="subtitle1" component="h2" flexGrow={1} fontWeight={600}>
                    {title}
                </Typography>
                <Tooltip title={fullscreenTooltip}>
                    <IconButton size="small" onClick={onFullscreen} aria-label={fullscreenTooltip}>
                        <Fullscreen />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box flexGrow={1} minHeight={0} display="flex" flexDirection="column">
                {tableNode}
            </Box>
        </Box>
    );
